"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RehabilitationColonies = function RehabilitationColonies(props) {
	return _react2.default.createElement(
		_SvgIcon2.default,
		(0, _extends3.default)({ viewBox: "0 0 511.997 511.997", className: "custom-icon" }, props),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M144.061,303.723v196.578c0,6.398,5.188,11.587,11.587,11.587c6.398,0,11.587-5.188,11.587-11.587V302.465 C160.007,305.294,152.109,305.906,144.061,303.723z" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M190.687,263.163c1.043,8.115-0.615,16.418-4.965,23.696c2.277,2.035,3.721,4.985,3.721,8.271v23.06 c0,6.398,5.188,11.587,11.587,11.587s11.587-5.188,11.587-11.587v-23.06C212.615,280.582,203.502,268.13,190.687,263.163z" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("circle", { cx: "377.893", cy: "44.528", r: "44.528" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M503.505,185.005l-53.124-54.528l-0.509-2.656c-2.158-15.773-16.336-27.247-32.377-25.867 c-5.382,0.462-40.657,3.495-53.445,4.595c-7.139,0.614-13.476,3.677-18.266,8.286l-65.345,21.6l-85.853,0.717 c-11.122,0.093-20.063,9.184-19.971,20.306c0.094,11.12,9.183,20.063,20.307,19.97l89.009-0.743 c2.091-0.017,4.167-0.36,6.152-1.016l48.343-15.98c1.12,13.023,8.908,103.616,10.577,123.033l-33.276,73.633 c-0.669,1.479-1.187,3.021-1.547,4.603l-27.452,120.741c-2.963,13.038,5.202,26.01,18.24,28.974 c13.039,2.964,26.011-5.203,28.974-18.24l26.91-118.362l38.628-85.475l12.768-1.098c-8.913,56.778-4.586,29.209-13.743,87.54 c-0.651,4.139-0.214,8.376,1.264,12.298l40.839,108.273c4.72,12.515,18.69,18.825,31.194,14.108 c12.51-4.719,18.826-18.684,14.109-31.194L447.33,376.23l9.7-61.791c-17.092-7.004-27.741-25.571-23.587-44.874 c2.657-12.35,10.439-48.521,13.124-60.999l-33.054-58.11l53.542,54.957l-14.678,68.224c-2.324,10.796,4.505,21.604,15.48,23.966 h0.001c10.928,2.354,21.637-4.654,23.966-15.479l16.954-78.798C510.206,196.685,508.191,189.816,503.505,185.005z" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("circle", { cx: "128.538", cy: "58.093", r: "43.218" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M162.42,249.996l-61.7-29.905l-9.281-68.224l22.829,55.478l15.497,7.511l9.444-62.103 c2.363-15.54-8.319-30.053-23.859-32.417l-38.658-5.879c-15.54-2.364-30.053,8.318-32.417,23.859L20.871,296.469l18.942,80.084 L4.195,478.352c-4.613,13.182,2.335,27.608,15.517,32.219c13.172,4.612,27.605-2.329,32.219-15.517l38.274-109.385 c1.727-4.937,1.881-10.287,0.441-15.316l-16.253-56.734l9.076,1.38l28.814,56.487l-3.801,114.377 c-0.419,12.601,8.457,23.352,20.458,25.664c-1.453-3.453-2.258-7.246-2.258-11.227V296.042 c-10.709-5.191-55.276-26.791-60.396-29.272c-15.868-7.692-21.519-24.076-20.716-32.46l7.052-73.681l10.248,75.337 c0.884,6.488,4.938,12.229,10.996,15.165c37.534,18.192,10.054,4.873,71.264,34.54c9.219,4.464,20.213,1.148,25.491-7.411 C176.911,268.079,172.826,255.04,162.42,249.996z" })
			)
		),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null)
	);
};

exports.default = RehabilitationColonies;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/rehabilitationcolonies.js
// module id = 1942
// module chunks = 1143